import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-launch',
	templateUrl: './icon-launch.component.svg',
})
export class IconLaunchComponent {}
